var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.item.class,style:(_vm.item.style)},[_vm._v(" "+_vm._s(_vm.item.formatter && _vm.item.formatter(_vm.formData[_vm.item.prop]) || _vm.formData[_vm.item.prop])+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }